import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ServiceCaller } from "./ServiceCaller";
import { environment } from '../../../environments/environment';


@Injectable()
export class AuthService {

    private isLoggedIn: boolean = false;
    redirectUrl: string = "/dashboard";
    get displayName(): string {
        return localStorage.getItem("USER_DIS");
    }
    get description(): string {
        return localStorage.getItem("USER_DES");
    }

    constructor( @Inject(Router) private router: Router, public service: ServiceCaller) {
        this.checkLogin(this.redirectUrl);
    }

    logout() {
        localStorage.removeItem("token");
        this.router.navigate(['/login']);
    }

    login(username, password): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.service.post("/Account/SignIn", { username: username, password: password }).then(data => {
                this.isLoggedIn = true;
                  localStorage.setItem("token",data)
                
              // localStorage.setItem('UT',data.);
                resolve(true);
            }).catch(c => {
                this.isLoggedIn = false;
                reject(c);
            });
        });
    }

    checkLogin(url: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
           var token = localStorage.getItem('token');
            if (token)
                resolve(true);
            else {
                this.redirectLogin(url);
                reject(false);
            }
            // var token = localStorage.getItem('token');
            // if (this.isLoggedIn == true && token)
            //     resolve(true);
            // if (token) {
            //    this.isLoggedIn = false;
            //    this.service.post("/ADM/Security/SignIn", (data) => {
            //        localStorage.setItem("token", data.Token);
            //        this.isLoggedIn = true;
            //        resolve(true);
            //    }, {
            //            token: token
            //        }, () => {
            //            localStorage.setItem('token', null);
            //            resolve(false);
            //            this.redirectLogin(url);
            //        });
            // } else {
            //    resolve(false);
            //    this.redirectLogin(url);
            // }

        });
    }

    private redirectLogin(url: string) {
        this.isLoggedIn = false;
        this.redirectUrl = url;
        this.router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/services/AuthService.ts